import { formatJsonDataset as fjd } from "../../components/renderers";

export const kpisconfig = {

  objective: {
    service: {
      name: 'objective',
      title: 'Objectives',
      num: true,
      fields: ['rid','nam','shc','dsc','ati','atn','atc','opi','opn','opc','cci','ccn','ccc','osi','osn','osc','axi','axn','axc','edi','edn','edc','exi','sts','ast','stp'],
      grid: [
        ['nam','Name'],
        ['shc','Code'],
        ['atn','Type'],
        ['opn','Parent'],
        ['ccn','Cost Center'],
        ['osn','State'],
        ['axn','Axis'],
        ['dsc','Description'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Name', v:'nam' },
          { t:'Code', v:'shc' },
          { t:'Axis', v:'axn' }
        ],
        def:'nam'
      },
      eform: [
        { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
        { id:'shc', label:'Code', type:'tf', req:1, ops:{} },
        { id:'ati', label:'Type', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'objectivetype' } },
        { id:'opi', label:'Parent Objective', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'objective' } },
        { id:'cci', label:'Cost Center', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'costcenter' } },
        { id:'osi', label:'State', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'objectivestate' } },
        { id:'axi', label:'Axis', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'axis' } },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },
  
  kpimaster: {
    service: {
      name: 'kpimaster',
      title: 'KPI Master',
      num: true,
      fields: ['rid','nam','shc','kti','ktn','ktc','kfi','kfn','kfc','umi','umn','umc','obi','obn','obc','fml','ipt','ksi','ksn','ksc','edi','edn','edc','dsc','exi','sts','ast','stp'],
      grid: [
        ['nam','Name'],
        ['shc','Code'],
        ['ktn','Type'],
        ['kfn','Frequency'],
        ['umn','UOM'],
        ['obn','Objective'],
        ['ksn','State'],
        ['fml','Formula'],
        ['ipt','Interpretation'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Name', v:'nam' },
          { t:'Code', v:'shc' },
          { t:'Objective', v:'obn' }
        ],
        def:'nam'
      },
      eform: [
        { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
        { id:'shc', label:'Code', type:'tf', req:1, ops:{} },
        { id:'kti', label:'Type', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpitype' } },
        { id:'kfi', label:'Frequency', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpifrequency' } },
        { id:'umi', label:'UOM', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'uom' } },
        { id:'obi', label:'Objective', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'objective' } },
        { id:'fml', label:'Formula', type:'ta', req:0, ops:{} },
        { id:'ipt', label:'Interpretation', type:'ta', req:0, ops:{} },
        { id:'ksi', label:'State', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpistate' } },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  kpiplan: {
    service: {
      name: 'kpiplan',
      title: 'KPI Plans',
      num: true,
      fields: ['rid','kpi','kpn','kpc','bpi','bpn','bpc','bci','bcn','bcc','cci','ccn','ccc','blv','tgv','tmn','tmx','pti','ptn','ptc','psi','psn','psc','edi','edn','edc','dsc','exi','sts','ast','stp'],
      grid: [
        ['kpn','KPI'],
        ['bpn','Period'],
        ['bcn','Cycle'],
        ['ccn','Cost Center'],
        ['blv','Baseline'],
        ['tgv','Target'],
        ['tmn','Min Threshold'],
        ['tmx','Max Threshold'],
        ['ptn','Type'],
        ['psn','State'],
        ['dsc','Description'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'KPI', v:'kpn' },
          { t:'Period', v:'bpn' },
          { t:'Cost Center', v:'ccn' }
        ],
        def:'kpn'
      },
      eform: [
        { id:'kpi', label:'KPI', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpimaster' } },
        { id:'bpi', label:'Period', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'budgetperiod' } },
        { id:'bci', label:'Cycle', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'budgetcycle' } },
        { id:'cci', label:'Cost Center', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'costcenter' } },
        { id:'blv', label:'Baseline Value', type:'nf', req:0, ops:{} },
        { id:'tgv', label:'Target Value', type:'nf', req:0, ops:{} },
        { id:'tmn', label:'Threshold Min', type:'nf', req:0, ops:{} },
        { id:'tmx', label:'Threshold Max', type:'nf', req:0, ops:{} },
        { id:'pti', label:'Plan Type', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpiplantype' } },
        { id:'psi', label:'Plan State', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpiplanstate' } },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  kpiactivitylink: {
    service: {
      name: 'kpiactivitylink',
      title: 'KPI Activity Links',
      num: true,
      fields: ['rid','kpi','kpn','kpc','aci','acn','acc','cwt','edi','edn','edc','dsc','exi','sts','ast','stp'],
      grid: [
        ['kpn','KPI'],
        ['acn','Activity'],
        ['cwt','Contribution Weight'],
        ['dsc','Description'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'KPI', v:'kpn' },
          { t:'Activity', v:'acn' }
        ],
        def:'kpn'
      },
      eform: [
        { id:'kpi', label:'KPI', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpimaster' } },
        { id:'aci', label:'Activity', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'activity' } },
        { id:'cwt', label:'Contribution Weight', type:'nf', req:0, ops:{} },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  kpioutputlink: {
    service: {
      name: 'kpioutputlink',
      title: 'KPI Output Links',
      num: true,
      fields: ['rid','kpi','kpn','kpc','opi','opn','opc','cwt','edi','edn','edc','dsc','exi','sts','ast','stp'],
      grid: [
        ['kpn','KPI'],
        ['opn','Output'],
        ['cwt','Contribution Weight'],
        ['dsc','Description'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'KPI', v:'kpn' },
          { t:'Output', v:'opn' }
        ],
        def:'kpn'
      },
      eform: [
        { id:'kpi', label:'KPI', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpimaster' } },
        { id:'opi', label:'Output', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'activityoutput' } },
        { id:'cwt', label:'Contribution Weight', type:'nf', req:0, ops:{} },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  kpiplanactivitylink: {
    service: {
      name: 'kpiplanactivitylink',
      title: 'KPI Plan Activity Links',
      num: true,
      fields: ['rid','pni','kpc','api','acn','acc','cwt','edi','edn','edc','dsc','exi','sts','ast','stp'],
      grid: [
        ['kpc','KPI Plan'],
        ['acn','Activity Plan'],
        ['cwt','Contribution Weight'],
        ['dsc','Description'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'KPI Plan', v:'kpc' },
          { t:'Activity Plan', v:'acn' }
        ],
        def:'kpc'
      },
      eform: [
        { id:'pni', label:'KPI Plan', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpiplan' } },
        { id:'api', label:'Activity Plan', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'activityplan' } },
        { id:'cwt', label:'Contribution Weight', type:'nf', req:0, ops:{} },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  kpiperformance: {
    service: {
      name: 'kpiperformance',
      title: 'KPI Performance',
      num: true,
      fields: ['rid','pni','kpc','pdt','acv','vav','com','evi','psi','psn','psc','edi','edn','edc','exi','sts','ast','stp'],
      grid: [
        ['kpc','KPI Plan'],
        ['pdt','Performance Date'],
        ['acv','Actual Value'],
        ['vav','Variance'],
        ['com','Commentary'],
        ['evi','Evidence'],
        ['psn','State'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'KPI Plan', v:'kpc' },
          { t:'Date', v:'pdt' }
        ],
        def:'kpc'
      },
      eform: [
        { id:'pni', label:'KPI Plan', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpiplan' } },
        { id:'pdt', label:'Performance Date', type:'df', req:1, ops:{} },
        { id:'acv', label:'Actual Value', type:'nf', req:1, ops:{} },
        { id:'vav', label:'Variance Value', type:'nf', req:0, ops:{} },
        { id:'com', label:'Commentary', type:'ta', req:0, ops:{} },
        { id:'evi', label:'Evidence Info', type:'jf', req:0, ops:{} },
        { id:'psi', label:'State', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'kpiperfstate' } },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd, evi:fjd } }
  },

  objectivecontract: {
    service: {
      name: 'objectivecontract',
      title: 'Objective Contracts',
      num: true,
      fields: ['rid','rix','sti','stn','stc','cyr','vrn','pci','pcy','pcv','ptt','ptc','ins','dep','srv','cat','mai','man','mac','msn','spr','ifr','inr','exr','geq','seq','edl','dmn','spl','xpr','csi','csn','csc','dcd','exi','sts','ast','stp'],
      grid: [
        ['stn','Staff'],
        ['stc','Staff Code'],
        ['cyr','Year'],
        ['vrn','Version'],
        ['ptt','Position Title'],
        ['ptc','Position Code'],
        ['ins','Institution'],
        ['dep','Department'],
        ['srv','Service'],
        ['cat','Category'],
        ['man','Mission Alignment'],
        ['csn','State'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Staff', v:'stn' },
          { t:'Position Title', v:'ptt' },
          { t:'Position Code', v:'ptc' },
          { t:'Department', v:'dep' }
        ],
        def:'stn'
      },
      eform: [
        { id:'sti', label:'Staff', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'staff' } },
        { id:'cyr', label:'Contract Year', type:'nf', req:1, ops:{} },
        { id:'vrn', label:'Version No', type:'nf', req:0, ops:{} },
        { id:'pci', label:'Parent Contract ID', type:'nf', req:0, ops:{} },
        { id:'ptt', label:'Position Title', type:'tf', req:1, ops:{} },
        { id:'ptc', label:'Position Code', type:'tf', req:1, ops:{} },
        { id:'ins', label:'Institution', type:'tf', req:0, ops:{} },
        { id:'dep', label:'Department', type:'tf', req:0, ops:{} },
        { id:'srv', label:'Service', type:'tf', req:0, ops:{} },
        { id:'cat', label:'Category', type:'tf', req:0, ops:{} },
        { id:'mai', label:'Mission Alignment ID', type:'nf', req:0, ops:{} },
        { id:'msn', label:'Mission', type:'ta', req:0, ops:{} },
        { id:'spr', label:'Superior Relation', type:'ta', req:0, ops:{} },
        { id:'ifr', label:'Inferior Relation', type:'ta', req:0, ops:{} },
        { id:'inr', label:'Internal Relations', type:'ta', req:0, ops:{} },
        { id:'exr', label:'External Relations', type:'ta', req:0, ops:{} },
        { id:'geq', label:'General Equipment', type:'ta', req:0, ops:{} },
        { id:'seq', label:'Specific Equipment', type:'ta', req:0, ops:{} },
        { id:'edl', label:'Education Level', type:'tf', req:0, ops:{} },
        { id:'dmn', label:'Domain', type:'tf', req:0, ops:{} },
        { id:'spl', label:'Speciality', type:'tf', req:0, ops:{} },
        { id:'xpr', label:'Experience', type:'tf', req:0, ops:{} },
        { id:'csi', label:'State ID', type:'nf', req:1, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  contractindicator: {
    service: {
      name: 'contractindicator',
      title: 'Contract Indicators',
      num: true,
      fields: ['rid','rix','oci','ocy','ocv','opt','ini','inn','inc','inm','sqn','dcd','exi','sts','ast','stp'],
      grid: [
        ['opt','Contract'],
        ['ocy','Year'],
        ['ocv','Version'],
        ['inn','Indicator'],
        ['inc','Indicator Code'],
        ['inm','Indicator Name'],
        ['sqn','Seq No'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Contract', v:'opt' },
          { t:'Indicator', v:'inn' },
          { t:'Indicator Name', v:'inm' }
        ],
        def:'inm'
      },
      eform: [
        { id:'oci', label:'Contract ID', type:'nf', req:1, ops:{} },
        { id:'ini', label:'Indicator ID', type:'nf', req:0, ops:{} },
        { id:'inm', label:'Indicator Name', type:'tf', req:1, ops:{} },
        { id:'sqn', label:'Seq No', type:'nf', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  contractvalidation: {
    service: {
      name: 'contractvalidation',
      title: 'Contract Validations',
      num: true,
      fields: ['rid','rix','oci','ocy','ocv','opt','vsi','vsn','vsc','vro','vfn','vld','vdt','rmk','sqn','dcd','exi','sts','ast','stp'],
      grid: [
        ['opt','Contract'],
        ['ocy','Year'],
        ['ocv','Version'],
        ['vsn','Validator'],
        ['vsc','Validator Code'],
        ['vro','Role'],
        ['vfn','Full Name'],
        ['vld','Validated'],
        ['vdt','Validation Date'],
        ['rmk','Remarks'],
        ['sqn','Seq No'],
        ['exi','Extra Info'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Contract', v:'opt' },
          { t:'Validator', v:'vsn' },
          { t:'Role', v:'vro' },
          { t:'Full Name', v:'vfn' }
        ],
        def:'vfn'
      },
      eform: [
        { id:'oci', label:'Contract ID', type:'nf', req:1, ops:{} },
        { id:'vsi', label:'Validator ID', type:'nf', req:0, ops:{} },
        { id:'vro', label:'Validation Role', type:'tf', req:1, ops:{} },
        { id:'vfn', label:'Full Name', type:'tf', req:1, ops:{} },
        { id:'vld', label:'Validated', type:'cb', req:0, ops:{} },
        { id:'vdt', label:'Validation Date', type:'df', req:0, ops:{} },
        { id:'rmk', label:'Remarks', type:'ta', req:0, ops:{} },
        { id:'sqn', label:'Seq No', type:'nf', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },

  globalobjective: {
    service: {
      name: 'globalobjective',
      title: 'Gllobal Objectives',
      num: true,
      fields: ['rid','nam','shc','dsc','ati','atn','atc','opi','opn','opc','cci','ccn','ccc','osi','osn','osc','axi','axn','axc','edi','edn','edc','exi','sts','ast','stp'],
      grid: [
        ['nam','Name'],
        ['shc','Code'],
        ['atn','Type'],
        ['opn','Parent'],
        ['ccn','Cost Center'],
        ['osn','State'],
        ['axn','Axis'],
        ['dsc','Description'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Name', v:'nam' },
          { t:'Code', v:'shc' },
          { t:'Axis', v:'axn' }
        ],
        def:'nam'
      },
      eform: [
        { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
        { id:'shc', label:'Code', type:'tf', req:1, ops:{} },
        { id:'ati', label:'Type', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'objectivetype' } },
        { id:'opi', label:'Parent Objective', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'objective' } },
        { id:'cci', label:'Cost Center', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'costcenter' } },
        { id:'osi', label:'State', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'objectivestate' } },
        { id:'axi', label:'Axis', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'axis' } },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },
  
  specificobjective: {
    service: {
      name: 'specificobjective',
      title: 'Specific Objectives',
      num: true,
      fields: ['rid','nam','shc','dsc','ati','atn','atc','opi','opn','opc','cci','ccn','ccc','osi','osn','osc','axi','axn','axc','edi','edn','edc','exi','sts','ast','stp'],
      grid: [
        ['nam','Name'],
        ['shc','Code'],
        ['atn','Type'],
        ['opn','Parent'],
        ['ccn','Cost Center'],
        ['osn','State'],
        ['axn','Axis'],
        ['dsc','Description'],
        ['stp','Stamp']
      ],
      menu: {
        mnu: [
          { t:'Name', v:'nam' },
          { t:'Code', v:'shc' },
          { t:'Axis', v:'axn' }
        ],
        def:'nam'
      },
      eform: [
        { id:'nam', label:'Name', type:'tf', req:1, ops:{} },
        { id:'shc', label:'Code', type:'tf', req:1, ops:{} },
        { id:'ati', label:'Type', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'objectivetype' } },
        { id:'opi', label:'Parent Objective', type:'fa', req:0, ops:{}, cp:{ t:'bcs', s:'objective' } },
        { id:'cci', label:'Cost Center', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'costcenter' } },
        { id:'osi', label:'State', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'objectivestate' } },
        { id:'axi', label:'Axis', type:'fa', req:1, ops:{}, cp:{ t:'bcs', s:'axis' } },
        { id:'dsc', label:'Description', type:'ta', req:0, ops:{} },
        { id:'exi', label:'Extra Info', type:'jf', req:0, ops:{} },
        { id:'sts', label:'Status', type:'fa', req:0, ops:{}, cp:{ t:'lcs', s:'status' } },
      ]
    },
    create: true,
    actions: { add:'Add', edit:'Edit', del:'Delete', delete:'Delete', view:'View' },
    panels: { add:'simple', edit:'simple', delete:'dialog', view:'simple' },
    formatters: { grid: { exi:fjd } }
  },
  
  

};
